var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-2 ma-2" },
    [
      _c(
        "div",
        { staticClass: "overline" },
        [
          _c(
            "v-row",
            { staticClass: "mx-auto d-flex align-center overline" },
            [
              _c("v-icon", { attrs: { small: "" } }, [
                _vm._v(" mdi-comment-text-multiple-outline ")
              ]),
              _c(
                "p",
                { staticClass: "font-weight-light caption pa-2 mx-0 my-0" },
                [_vm._v("Comentarios")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        _vm._l(_vm.items, function(i, k) {
          return _c(
            "v-col",
            { key: k, staticClass: "my-2", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-2 mx-2 fill-height" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-1 justify-space-between overline" },
                    [
                      _c("div", { staticClass: "font-weight-bold" }, [
                        _vm._v(" " + _vm._s(i.commentarySection.name) + " ")
                      ]),
                      _c("div", [
                        _vm._v(" " + _vm._s(_vm.setFormatDate(i.date)) + " ")
                      ])
                    ]
                  ),
                  _c("v-card-text", { staticClass: "text-justify pa-1" }, [
                    _vm._v(_vm._s(i.comment))
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }